// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as SelectTemplateCmp from "./SelectTemplateCmp.bs.js";
import * as TemplateDetailsCmp from "./TemplateDetailsCmp.bs.js";
import * as SendSMSStepperConfig from "./SendSMSStepperConfig.bs.js";
import * as ProgressStepper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepper.bs.js";
import * as ProgressStepperHook$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepperHook.bs.js";

function SendSmsStepperCmp(Props) {
  var current_stepper_state = Props.current_stepper_state;
  var template_list = Props.template_list;
  var on_select_template = Props.on_select_template;
  var selected_template = Props.selected_template;
  var match = ProgressStepperHook$Catalyst.useStepper(SendSMSStepperConfig.steppers, current_stepper_state, ProgressStepper$Catalyst.Classes.make("send-sms-stepper-root", undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined);
  var resetStepper = match.resetStepper;
  var setCompleted = match.setCompleted;
  var setActive = match.setActive;
  React.useEffect((function () {
          if (current_stepper_state) {
            Curry._1(setActive, /* TemplateDetails */1);
            Curry._1(setCompleted, /* SelectTemplate */0);
          } else {
            Curry._1(setActive, /* SelectTemplate */0);
            Curry._1(resetStepper, /* SelectTemplate */0);
          }
          
        }), [current_stepper_state]);
  return React.createElement("div", {
              className: "sms-stepper-cmp"
            }, match.steppers_cmp, match.active ? React.createElement(TemplateDetailsCmp.make, {
                    selected_template: selected_template
                  }) : React.createElement(SelectTemplateCmp.make, {
                    template_list: template_list,
                    on_select_template: on_select_template,
                    selected_template: selected_template
                  }));
}

var make = SendSmsStepperCmp;

export {
  make ,
  
}
/* react Not a pure module */
